<template>
  <div>
    <q-dialog
      v-model="show"
      :maximized="maximized"
      @input="(val) => $emit('input', val)"
    >
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header>
          <q-toolbar>
            <q-toolbar-title>{{ label }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>

        <q-page-container class="scroll page-container">
          <crud-form
            v-if="forms"
            ref="crudForm"
            :form="forms[0]"
            :model="forms[0].dadosForm"
            @action-click="actionClick"
          >
            <q-stepper
              animated
              v-model="currentStep"
              ref="stepper"
              color="primary"
              class="tw-h-full"
            >
              <q-step
                :name="0"
                :title="$gettext('FINANCIAL_DATA')"
                :done="step > 0"
                class="no-scroll-step"
              >
                <div class="tw-flex tw-flex-row tw-justify-between">
                  <div class="tw-w-1/2 tw-mr-4">

                    <invoice-settlement-form>
                      <template slot="header">
                        <span class="title-header">
                          {{ $gettext('PERIOD') }}
                        </span>
                      </template>
                      <template slot="content">
                        <div class="row q-col-gutter-md">
                          <div class="row q-col-gutter-md">
                           <date-my
                              v-model="forms[0].dadosForm.startDate.inicial"
                              :rules="[val => !!val || 'Data é obrigatória']"
                              class="col-6"
                              :navigation-max-year-month="forms[0].dadosForm.startDate.final"
                              :label="$gettext('PERIOD') + ' ' + $gettext('INITIAL')"
                              />
                            <date-my
                              v-model="forms[0].dadosForm.startDate.final"
                              class="col-6"
                              :navigator-min-year-month="forms[0].dadosForm.startDate.inicial"
                              :label="$gettext('PERIOD') + ' ' + $gettext('FINAL')"
                              />
                          </div>
                        </div>
                      </template>
                    </invoice-settlement-form>
                  </div>
                  <div class="tw-w-1/2">
                    <invoice-settlement-form>
                      <template slot="header">
                        <span class="title-header">
                          {{ $gettext('CONSUMER_UNIT') }}
                        </span>
                      </template>
                      <template slot="content">
                        <div class="row q-col-gutter-md">
                            <crud-input
                              class="col-6"
                              nmInput="quantityLaps"
                              :required="true"
                            />
                            <crud-input
                              class="col-6"
                              nmInput="consumerUnitType"
                              :required="true"
                            />
                        </div>
                      </template>
                    </invoice-settlement-form>
                  </div>
                </div>
                <div class="tw-flex tw-flex-row tw-justify-between">
                  <div class="tw-w-1.5/2 tw-mr-4">
                    <invoice-settlement-form>
                      <template #content>
                        <div class="consumerUnitCategorys q-col-gutter-md">
                          <compositions
                            class="col-12 q-px-sm"
                            :form="forms[0]"
                            :model="forms[0].dadosForm"
                            @action-click="actionClick"
                            :hideCompositions="['invoiceSettlementFiles','invoiceSettlementInvoices']"
                          >
                          </compositions>
                        </div>
                      </template>
                    </invoice-settlement-form>
                  </div>
                </div>
              </q-step>
              <q-step
                :name="1"
                :title="$gettext('INVOICES_SUMMARY_STEP')"
                :done="step > 1"
                class="scroll-step"
              >
                <div class="table-container">
                  <compositions :hideCompositions="['invoiceSettlementFiles','consumerUnitCategorys']">
                     <composition
                        slot="invoiceSettlementInvoices"
                        slot-scope="dados"
                        v-bind="dados"

                      >
                        <template slot="table" slot-scope="dadosTable">
                          <service-request-invoice-settlement-datable
                            :fields="dadosTable.fields"
                            :invoices="invoices"
                            noneselect
                            rowKey="boundResidue"
                            :columnEdit="paintCell"
                          />
                        </template>
                      </composition>
                  </compositions>
                </div>
              </q-step>
              <q-step
                :name="2"
                :title="$gettext('ATTACHMENT_INFO_STEP')"
                :done="step > 2"
                class="no-scroll-step"
              >
                <div id="attachment-info">
                 <crud-input
                    class="col-12"
                    nmInput="observation"
                    :required="true"
                  />
                  <compositions :hideCompositions="['invoiceSettlementInvoices','consumerUnitCategorys']"  >
                    <composition
                      slot="invoiceSettlementFiles"
                      slot-scope="dados"
                      ref="composition"
                      v-bind="dados"/>
                  </compositions>
                </div>
              </q-step>
            </q-stepper>
          </crud-form>
        </q-page-container>
        <q-footer class="footer-container">
          <div class="footer-content" v-if="forms" >
            <q-btn
              v-if="currentStep > 0"
              class="tw-w-auto tw-px-6 tw-shrink-0 tw-whitespace-nowrap"
              :label="$gettext('BACK')"
              color="grey-7"
              @click="prevStep"
            />
            <q-btn
              :disable="(!forms[0].dadosForm.observation && isLastStep)"
              class="tw-w-auto tw-px-6 tw-shrink-0 tw-whitespace-nowrap"
              :label="
              isLastStep ? $gettext('SEND_TO_APPROVAL') : $gettext('CONTINUE')
            "
              color="info"
              @click="nextStep"
            />
          </div>
        </q-footer>
      </q-layout>
    </q-dialog>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtDynamicForm, JtCrud, JtDatetimeRange } from 'jtech-webcomps'
import ServiceRequestInvoiceSettlementController from './ServiceRequestInvoiceSettlementController'
import MainContentLayout from '../../../Layout/MainContentLayout.vue'
import { QBtn } from 'quasar'
import InvoiceSituation from '../component/InvoiceSituation.vue'
import moment from 'moment'
import ServiceRequestInvoiceSettlementDatable from './ServiceRequestInvoiceSettlementDatatable.vue'
import InvoiceSettlementForm
  from '../component/InvoiceSettlementForm.vue'
import ServiceRequestInvoiceSettlementDate from './ServiceRequestInvoiceSettlementDate.vue'

const { form, input, compositions, composition } = JtCrud

@Component({
  name: 'ServiceRequestInvoiceSettlementCancellation',
  components: {
    'crud-form': form,
    'crud-input': input,
    compositions,
    composition,
    MainContentLayout,
    QBtn,
    JtDataTable,
    JtDynamicForm,
    InvoiceSituation,
    ServiceRequestInvoiceSettlementDatable,
    InvoiceSettlementForm,
    JtDatetimeRange,
    'date-my': ServiceRequestInvoiceSettlementDate
  },
  props: {
    consumerUnit: String,
    protocol: String,
    label: String,
    show: {
      type: Boolean,
      default: false
    },
    maximized: {
      type: Boolean,
      default: false
    }
  }
})

class ServiceRequestInvoiceSettlementCancellation extends Vue {
  serviceRequestInvoiceSettlementController =
    ServiceRequestInvoiceSettlementController.getInstance();

  forms = null;
  moment = moment;
  currentStep = 0;
  lastStep = 2;
  datatable = null
  invoices = []
  step = 0

  async mounted () {
    await this.load()
  }

  get fields () {
    return this.forms?.[0]?.fields ?? []
  }

  get buttons () {
    return this.forms?.[0]?.buttons ?? []
  }

  get columns () {
    return this.datatable[0].inputs[0].columns
  }

  async load () {
    this.forms = await this.serviceRequestInvoiceSettlementController.createBillingCancellation(
      this.consumerUnit
    )
    this.forms[0].dadosForm.startDate = { initial: null, final: null, inicial: null }
    this.forms[0].observation = null
  }

  async apply () {
    if (!this.$refs.composition.isValid) {
      this.$messageBox.showWarning(this.$gettext('FULFILL_FIELDS_MESSAGE'))
      return
    }

    const params = {
      ...this.forms[0].dadosForm,
      nominalValue: this.nominalValue,
      consumerUnit: this.consumerUnit,
      owner: this.owner,
      invoiceSettlementInvoices: this.invoices
    }

    try {
      this.loading = true
      await this.serviceRequestInvoiceSettlementController.applyCancellation(params)
      this.$emit('input', false)
    } catch (error) {
      this.$messageBox.showError(this.$gettext('ERROR_APPLYING_EXEMPTION'))
      console.error(`${this.ERROR_MESSAGES.APPLY_EXEMPTION_ERROR}:`, {
        error,
        params
      })
    } finally {
      this.loading = false
    }
  }

  isValidForm () {
    const form = this.forms[0]
    let errorMessages = []

    errorMessages = errorMessages.concat(this.validateConsumerUnitCategorys(form))
    errorMessages = errorMessages.concat(this.validateQuantityLaps(form))
    errorMessages = errorMessages.concat(this.validateStartDate(form))

    if (errorMessages.length > 0) {
      const message = errorMessages.join(', ')
      this.$messageBox.showWarning(`${this.$gettext('REQUIRED_FIELD')}: ${message}`)
      return false
    }

    return true
  }

  validateConsumerUnitCategorys (form) {
    const errors = []
    const inputLabel = form.inputs.find(input => input.model === 'consumerUnitCategorys').label

    if (!form.dadosForm?.consumerUnitCategorys?.length) {
      errors.push(inputLabel)
    } else {
      const seenTypes = new Set()
      for (const category of form.dadosForm.consumerUnitCategorys) {
        if (seenTypes.has(category.consumerUnitType)) {
          errors.push(this.$gettext('DUPLICATE_CONSUMER_UNIT_CATEGORY'))
          break
        }
        seenTypes.add(category.consumerUnitType)
      }
    }
    return errors
  }

  validateQuantityLaps (form) {
    const errors = []
    const inputLabel = form.inputs.find(input => input.model === 'quantityLaps').label

    if (!form.dadosForm?.quantityLaps) {
      errors.push(inputLabel)
    }
    return errors
  }

  validateStartDate (form) {
    const errors = []
    const inputLabel = form.inputs.find(input => input.model === 'startDate').label
    if (!form.dadosForm?.startDate?.inicial) {
      errors.push(`${inputLabel} ${this.$gettext('INITIAL')}`)
    } else if (form.dadosForm?.startDate?.final && moment(form.dadosForm.startDate.inicial, 'MM/YYYY').isAfter(moment(form.dadosForm.startDate.final, 'MM/YYYY'), 'month')) {
      errors.push(this.$gettext('INITIAL_DATE_MUST_BE_BEFORE_FINAL_DATE'))
    }

    return errors
  }

  async onSelectChangeHandler () {
    if (!this.isValidForm()) {
      return false
    }
    const response = await this.serviceRequestInvoiceSettlementController.loadInvoicesByDate({ ...this.forms[0].dadosForm, consumerUnit: this.consumerUnit })
    this.invoices = response.invoices
    return true
  }

  get isStepInvalid () {
    if (this.currentStep === 0) {
      return (
        !this.forms?.[0]?.dadosForm?.concessionContractTariff ||
        !this.forms?.[0]?.dadosForm?.observation
      )
    }
    return false
  }

  get isLastStep () {
    return this.currentStep === this.lastStep
  }

  async nextStep () {
    if (this.currentStep === 0) {
      if (await this.onSelectChangeHandler()) { this.currentStep++ }
    } else if (this.isLastStep) {
      this.apply()
    } else {
      this.currentStep++
    }
  }

  async prevStep () {
    this.closeFileModal()
    this.currentStep--
  }

  closeFileModal () {
    if (this.$refs.fileModal) {
      this.$refs.fileModal.hide()
    }
  }
}
export default ServiceRequestInvoiceSettlementCancellation
</script>

<style scoped lang="stylus">
.modal-medium {
  min-height: 600px;
  max-height: 100vh;
  background-color: white;
}

:deep(.q-page-container) {
  height: calc(100vh - 120px);
  padding-bottom: 80px;
  box-shadow: none !important;
  background: transparent;
  overflow-y: auto;
  overflow-x: hidden;

  &:after {
    display: none;
  }
}

:deep(.q-stepper) {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

:deep(.q-stepper__content) {
  padding: 24px;
}

:deep(.no-scroll-step) {
  overflow: visible;

  .q-step-content {
    overflow-y: auto;
    overflow-x: hidden;
  }
}

:deep(.scroll-step) {
  .q-step-content {
    overflow: hidden;
    position: relative;
    height: 100%;

    .table-container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 80px;
      overflow-y: auto;
      padding: 24px;
      padding-bottom: 0;
    }
  }
}

.footer-container {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  min-height: 80px;
  background: white;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.1);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.footer-content {
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
}

.title-header {
  font-family: 'Roboto', sans-serif;
  font-size: 1.5em;
  font-weight 400;
  line-height 100%;
  letter-spacing:0;
}

hr {
  margin-bottom: 2.5em;
}

</style>
